import {createAction, props} from '@ngrx/store';
import {IInstitutionSettingsRequest} from '../models/institution-settings.request.model';

export enum InstitutionSettingsActions {
  UpdateInstitutionSettings = '[Institution-Settings component] Updates the institution',
  UpdateInstitutionSettingsSuccess = '[Institution-Settings effect] Update institution success',
  UpdateInstitutionSettingsFailure = '[Institution-Settings effect] Update institution failure',
}

export const updateInstitution = createAction(
  InstitutionSettingsActions.UpdateInstitutionSettings,
  props<{
    request: IInstitutionSettingsRequest;
    id: number;
  }>()
);

export const updateInstitutionSettingsSuccess = createAction(
  InstitutionSettingsActions.UpdateInstitutionSettingsSuccess
);
export const updateInstitutionSettingsFailure = createAction(
  InstitutionSettingsActions.UpdateInstitutionSettingsFailure
);
